import { render, staticRenderFns } from "./RoleEditor.vue?vue&type=template&id=13991bf8&"
import script from "./RoleEditor.vue?vue&type=script&lang=js&"
export * from "./RoleEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports